/**
 * All the configuration values used in this library should be referenced from here, for two reasons.
 * First, it avoid duplication of strings in multiple different places when we are using the same config key in
 * different code paths. Second, it centralizes all the values we can expect this library to reference into a single
 * place, which helps when we need to debug things.
 *
 * TODO: Audit all the code used in this lib and extract into this file place.
 */

const CLIENT_AUTH_ID = 'CLIENT_AUTH_ID'
const CLIENT_AUTH_NO_CONFIRMATION = 'CLIENT_AUTH_NO_CONFIRMATION'
const CLIENT_AUTH_SECRET = 'CLIENT_AUTH_SECRET'
const JWT_PUBLIC_KEY = 'JWT_PUBLIC_KEY'
const MS_UAA = 'MS_UAA'

module.exports = {
  CLIENT_AUTH_ID,
  CLIENT_AUTH_NO_CONFIRMATION,
  CLIENT_AUTH_SECRET,
  JWT_PUBLIC_KEY,
  MS_UAA,
}
